import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMinToe = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 71.955,
	height: 33.802,
	viewBox: "0 0 71.955 33.802",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_222",
		"data-name": "Group 222",
		transform: "translate(0)",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Group_211",
			"data-name": "Group 211",
			opacity: 0,
			children: /* @__PURE__ */ _jsx("g", {
				id: "Group_210",
				"data-name": "Group 210",
				transform: "translate(0)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_406",
					"data-name": "Path 406",
					d: "M1372.224,694.851H1300.27v-33.8h71.955Zm-71.435-.52H1371.7V661.569H1300.79Z",
					transform: "translate(-1300.27 -661.049)",
					fill: "#040505"
				})
			})
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group_221",
			"data-name": "Group 221",
			transform: "translate(20.274 4.013)",
			children: [/* @__PURE__ */ _jsxs("g", {
				id: "Group_220",
				"data-name": "Group 220",
				transform: "translate(0)",
				children: [
					/* @__PURE__ */ _jsx("g", {
						id: "Group_213",
						"data-name": "Group 213",
						transform: "translate(1.794)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_212",
							"data-name": "Group 212",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_407",
								"data-name": "Path 407",
								d: "M1368.027,684.564c-.363-.134-.781-.281-1.228-.438a22.628,22.628,0,0,1-4.847-2.083c-1.224-1.031-4.241-4.288-5.482-5.641a1.229,1.229,0,0,0-.63-.364c.035-.242.078-.5.145-.774.3-1.253.937-3.788,1.292-5.2a1.039,1.039,0,0,0-.754-1.261h0a1.039,1.039,0,0,0-1.262.755c-.356,1.417-.994,3.963-1.3,5.22a9.3,9.3,0,0,0-.251,3.087l-.072.093a3.282,3.282,0,0,1-1.964-.224,4.249,4.249,0,0,1-1.278-1.179c-.028-.037-.063-.065-.094-.1.153-.347.331-.789.565-1.372a14.826,14.826,0,0,0,.844-4.673,1.039,1.039,0,0,0-2.073-.16,13.025,13.025,0,0,1-.7,4.059c-.3.756-.49,1.189-.6,1.434a2.1,2.1,0,0,0-1.175.633,10.29,10.29,0,0,0-1.176,1.56,18.847,18.847,0,0,0-1.623,3.208,6.186,6.186,0,0,0-1.463,1.814,1.041,1.041,0,0,0-.095.969,6.47,6.47,0,0,0,4.085,3.255c2.762.936,11.942,3.042,12.376,3.141.2.036,4.915.878,7.8-.5l.093-.046c1.547-.771,2.433-1.961,2.375-3.2A2.241,2.241,0,0,0,1368.027,684.564Zm-19.278-8.94a1.035,1.035,0,0,1,.191-.041A1.059,1.059,0,0,0,1348.749,675.624Zm-.034.014a1,1,0,0,0-.133.057l.015-.01A.983.983,0,0,1,1348.715,675.638Zm18.744,11.033c.012.259-.314.815-1.29,1.274-1.885.9-5.348.547-6.478.342-.094-.022-9.466-2.171-12.128-3.074a5.371,5.371,0,0,1-2.551-1.652c.206-.292.394-.543.5-.666l.14-.067a1.051,1.051,0,0,0,.544-.627,15.539,15.539,0,0,1,1.556-3.163,7.285,7.285,0,0,1,.957-1.251c.015,0,.02.006.021.009a6.161,6.161,0,0,0,1.946,1.76,5.686,5.686,0,0,0,4.071.282,1.041,1.041,0,0,0,.665-.633c.074-.2.164-.413.254-.608,1.609,1.74,3.855,4.116,4.948,5.036.98.826,2.982,1.569,5.5,2.454.436.153.845.3,1.2.428C1367.454,686.568,1367.457,686.633,1367.459,686.671Z",
								transform: "translate(-1342.732 -668.771)",
								fill: "#040505"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_215",
						"data-name": "Group 215",
						transform: "translate(25.941 24.979)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_214",
							"data-name": "Group 214",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_408",
								"data-name": "Path 408",
								d: "M1393.352,716.835h-3.063a1.079,1.079,0,0,0-1.081.865,1.04,1.04,0,0,0,1.025,1.214h3.063a1.078,1.078,0,0,0,1.081-.865A1.04,1.04,0,0,0,1393.352,716.835Z",
								transform: "translate(-1389.194 -716.835)",
								fill: "#040505"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_217",
						"data-name": "Group 217",
						transform: "translate(10.726 24.979)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_216",
							"data-name": "Group 216",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_409",
								"data-name": "Path 409",
								d: "M1368.564,716.835h-7.552a1.079,1.079,0,0,0-1.081.865,1.04,1.04,0,0,0,1.025,1.214h7.552a1.078,1.078,0,0,0,1.081-.865A1.04,1.04,0,0,0,1368.564,716.835Z",
								transform: "translate(-1359.917 -716.835)",
								fill: "#040505"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_219",
						"data-name": "Group 219",
						transform: "translate(0 24.979)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_218",
							"data-name": "Group 218",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_410",
								"data-name": "Path 410",
								d: "M1343.437,716.835h-3.062a1.078,1.078,0,0,0-1.081.865,1.04,1.04,0,0,0,1.025,1.214h3.063a1.079,1.079,0,0,0,1.081-.865A1.04,1.04,0,0,0,1343.437,716.835Z",
								transform: "translate(-1339.279 -716.835)",
								fill: "#040505"
							})
						})
					})
				]
			}), /* @__PURE__ */ _jsx("path", {
				id: "Path_411",
				"data-name": "Path 411",
				d: "M1392.37,711.06l-2.767-2.768a1.09,1.09,0,0,0-.16-.13c-.024-.016-.051-.027-.077-.042a.963.963,0,0,0-.1-.053.919.919,0,0,0-.1-.032.861.861,0,0,0-.09-.027,1.047,1.047,0,0,0-.407,0,.9.9,0,0,0-.091.027.986.986,0,0,0-.1.032.939.939,0,0,0-.1.053c-.025.014-.052.026-.077.042a1.016,1.016,0,0,0-.159.13l-2.768,2.768a1.039,1.039,0,1,0,1.47,1.47l.994-.994v2.089a1.039,1.039,0,0,0,2.079,0v-2.089l.993.994a1.039,1.039,0,0,0,1.47-1.47Z",
				transform: "translate(-1361.267 -687.606)",
				fill: "#040505"
			})]
		})]
	})]
});
const ForwardRef = forwardRef(SvgMinToe);
export { ForwardRef as ReactComponent };
